exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input-address {\n  width: 100%;\n  display: inline-block;\n}\ninput-address div {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n          align-items: center;\n  align-content: center;\n  margin: 10px 0;\n}\ninput-address div label,\ninput-address div input,\ninput-address div select-country {\n  width: 100%;\n}\ninput-address div input {\n  min-height: 35px;\n}\ninput-address div select-country select {\n  width: 100%;\n  min-height: 35px;\n}\ninput-address[readonly] .ng-valid,\ninput-address[readonly] .ng-invalid {\n  color: inherit !important;\n  border-bottom-color: rgba(0, 0, 0, 0.4) !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"plugins":[{}]}!./src/app/common/components/input-address/input-address.component.less
// module id = dhVV
// module chunks = 1